/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * 性別
 */
export enum UserGender {
  MALE = "男性",
  FEMALE = "女性",
  OTHER = "その他",
  NO_ANSWER = "回答しない"
}
